import React, {useState, useEffect, useRef, Component} from 'react';
import './App.css';
import './progressBar.css';
import anime from 'animejs';





function App () {

  

//game values set up
const [tableNumber, setTableNumber] = useState(6)
const [randTableNumber, setRandTableNumber] = useState(0)
const [numberCorrect, setNumberCorrect ] = useState(0)
let [finishTotal, setFinishTotal] = useState(10)

const [ firstValue, setFirstValue ] = useState(0)
const [ secondValue, setSecondValue ] = useState(0)
const [ thirdValue, setThirdValue ] = useState(0)

const [ firstRndValue, setFirstRndValue ] = useState(0)
const [ secondRndValue, setSecondRndValue ] = useState(0)
const [ thirdRndValue, setThirdRndValue ] = useState(0)



//show start screen
const [showStartScreen, setShowStartScreen] = useState(true)

//show countdown screen

const [showCountdownScreen, setShowCountdownScreen] = useState(false)
const [messageCountdown, setMessageCountdown] = useState(["get ready"])
const [countdownTimerIsActive, setCountdownTimerIsActive] = useState(false);
let [countdownSeconds, setCountdownSeconds] = useState(3);

//show game

const [showGame, setShowGame] = useState(false)

//show endresultbit
const [showEndGame, setShowEndGame] = useState(false)

//buttons

const [answerColorOne, setAnswerColorOne] = useState("goldenrod")
const [answerColorTwo, setAnswerColorTwo] = useState("goldenrod")
const [answerColorThree, setAnswerColorThree] = useState("goldenrod")

//messages
const [congrats, setCongrats] = useState(<span >&nbsp;</span>)

const [arrayBoop, setArrayBoop] = useState([1,2,3])
const [messageArrayBoop, setMessageArrayBoop] = useState(["well done"])

//bonus bar
const [percentRange, setProgress] = useState(0);

//correct answers  
let [numberIncDec, setnumberIncDec] = useState(0)

//timer
const [seconds, setSeconds] = useState(0);
const [timerIsActive, setTimerIsActive] = useState(true);



//SOUNDS

// keyclicks
// function playbeeps() {

//   let context = new (window.AudioContext || window.webkitAudioContext)();
//   let oscillator = context.createOscillator();
  
//   oscillator.type = 'sine';
//   oscillator.frequency.value = 261.63;
//   oscillator.connect(context.destination);
 
 
//   let gain = context.createGain();
//   oscillator.connect(gain);
//   gain.connect(context.destination);
//   gain.gain.setValueAtTime(1, 0.05);
//   gain.gain.exponentialRampToValueAtTime(0.001, 10);
//   oscillator.start();
//   oscillator.stop(0.015);
//     }

  // function playGoBeep() {

  //     let context = new (window.AudioContext || window.webkitAudioContext)();
  //     let oscillator = context.createOscillator();
      
     
         
  //     oscillator.type = 'sine';
  //     oscillator.frequency.value = 440;
  //     oscillator.connect(context.destination);
     
     
  //     let gain = context.createGain();
  //     oscillator.connect(gain);
  //     gain.connect(context.destination);
  //     gain.gain.setValueAtTime(1, 0.05);
  //     gain.gain.exponentialRampToValueAtTime(0.001, 10);
  //     oscillator.start();
  //     oscillator.stop(0.2);
  //       }  


//ANIMATIONS

function animeJiggle() { anime({
  targets: '#firstanime',
  // Properties 
  
  translateY: 100,
  borderRadius: 50,
  // Property Parameters
  delay: 0,
  duration: 600,
  easing: 'linear',
  // Animation Parameters
  direction: 'reverse',
  
});  
}

function animeGrow() {
  anime({
  targets: "#countdownanime",
  translateX: 50,
   scale: {
    value: 2,
    delay: 0,
    duration: 10,
    
  },
  loop: true,
  
  })
}

let animetestvar1 = anime({
  targets: '.userGameTableChoice',
  translateX: '-10',
  delay: 20,
  duration: 1000,
  scale: 0.9,
  loop: false,
  direction: 'forward',
  easing: 'easeInCubic'
})


let animetestvar2 = anime({
  targets: '.userGameTableChoice2',
  translateX: '-10',
  delay: 20,
  duration: 1000,
  scale: 0.9,
  loop: false,
  direction: 'forward',
  easing: 'easeInCubic'
})


//play wrong sound

function playSoundWrong() {
 
  let soundWrong = new window.Pizzicato.Sound('sounds/brass.wav', function() {
  
    soundWrong.play()
  })

 
}

function playSoundCorrect() {
  let soundCorrect = new window.Pizzicato.Sound('sounds/xylo.wav', function() {
  
    soundCorrect.play();
  });

 }

 function playSoundThree() {
 let epiano = new window.Pizzicato.Sound('sounds/epiano.wav', function() {
  
  epiano.play();
});
}


//set the choice of the times table up
function setTableChoiceUp () {

   if (tableNumber < 12 ) {
    setTableNumber  (prevCount => prevCount = tableNumber +1)
    // playbeeps()
   }
   else {

setTableNumber(12)
   }
   
}

//set the choice of the times table down
function setTableChoiceDown () {
  if (tableNumber > 3 ) {
    setTableNumber  (prevCount => prevCount = tableNumber -1)
    // playbeeps()
   }
   else {

setTableNumber(2)
   }
 }

 //set the choice of the amount of questions up
function setFinishTotalUp () {

  if (finishTotal < 50) {
  setFinishTotal  (prevCount => prevCount = finishTotal +1)
  // playbeeps()
  }
  else {
    setFinishTotal(50)
  }
 }
 
  //set the choice of the amount of questions down
function setFinishTotalDown () {
  if (finishTotal > 2) {
  setFinishTotal  (prevCount => prevCount = finishTotal -1)
  // playbeeps()
  }
  else {
    setFinishTotal(1)
  }
}
 //set the choice of the amount of questions down

 function setFinishTotalButton() {
  
  setFinishTotal (finishTotal)
  // playbeeps()
 
  }


//shuffle the array for the order of the buttons
function shuffleArray() {

let array = [3,2,1]
setArrayBoop  (prevCount => prevCount = array) 
for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
}

return array

} 


 // start off the test with a random number in the buttons


 useEffect(() => {makeRandTableNumber()}, [])

//user game choice screen

useEffect( () => {userGameChoice ()}, [])


//title animation

function titleAnimate() {


anime.timeline({loop: false})
  .add({
    targets: '.gametitle',
    scale: [0, 1],
    duration: 2500,
    elasticity: 1000,
    opacity: 1,
    easing: "easeOutExpo",
    delay: 1000,
   
  })
  
}
   
  function userGameChoice () {

    //how many questions

    // alert("user game choice function. Shgoudle be gumpf about how you want game setup")
    setShowStartScreen(true)
    setShowCountdownScreen(false)
    setShowEndGame(false)
    setShowGame(false)
    titleAnimate()
    
       
    //start countdown
    
    //start game
    }
    
  //timer interval
  useEffect(() => {
    let interval = null;
    if (timerIsActive) {
      interval = setInterval(() => {
        setSeconds(seconds => seconds + 1);
      }, 1000);
    } else if (!timerIsActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timerIsActive, seconds]) 


 // countdown to game 
function countdownToGame(){

  setCountdownTimerIsActive(true)
  setShowCountdownScreen(true)
  setShowStartScreen(false)
  setShowEndGame(false)

  

        let countdowninterval = 3;
        if (setCountdownTimerIsActive && countdownSeconds > 1) {
          countdowninterval = setInterval(() => {
            
            
           setCountdownSeconds(countdownSeconds => countdownSeconds - 1)
           countdownSeconds --
          //  playGoBeep()
           animeGrow()

           if (countdownSeconds == 0) {
            
            clearInterval(countdowninterval);
            startGame()
          } else {

            if (countdownSeconds == -1) {
            
              clearInterval(countdowninterval);
              startGame()
            }
          }
          }, 1000);
        }
        
        
        return () => clearInterval(countdowninterval);
      
     
}







function startGame () {
  playSoundThree()
  setNumberCorrect(0)
  makeRandTableNumber()
  setShowStartScreen(false)
  setShowCountdownScreen(false)
  setShowEndGame(false)
  

 

  setTimeout(() => {
    
  
    // alert("this is startGame function")
  
    setShowGame(true)
    setSeconds(0)
    setProgress(0)
    setTimerIsActive(true)
    
}, 100);

clearTimeout()




}

    // set up the game questions and buttons  
    function makeRandTableNumber() {

    const randomnumber = (1 + Math.floor(Math.random() * (+12 - +1)) + +1 )
    const difficultnumber = ((((Math.floor(Math.random() * tableNumber)) + 1) * tableNumber) + (tableNumber -1))
    const meddifficultnumber = ((randomnumber * tableNumber) + (tableNumber * (Math.floor(Math.random() * tableNumber) + 1)))

      //set random multiplier
      setRandTableNumber (prevCount => prevCount = randomnumber)

      //set values for question display

      setFirstValue(prevValue => prevValue = randomnumber)

      setSecondValue(secondPrevValue => secondPrevValue = tableNumber)

      setThirdValue(thirdPrevValue => thirdPrevValue = randomnumber * tableNumber)

      // set random values for buttons

      setFirstRndValue(firstRndValue => firstRndValue = difficultnumber)

      setSecondRndValue(secondRndValue => secondRndValue = meddifficultnumber)

      setThirdRndValue(thirdRndValue => thirdRndValue = 36)


    //shuffle the button display order
    shuffleArray([1,2,3]) 

    if (numberCorrect == finishTotal-1) {
      endGame()
    }

    else {
    
      
    }

    }

//check value of the first button - this is always the wrong answer
function checkFirstValue() {
 return (firstRndValue === thirdValue ? incrementNumberCorrect() : wrongAnswerOne() )
} 

//check value of the second button - this is always the wrong answer
function checkSecondValue() {
 return (secondRndValue === thirdValue ? incrementNumberCorrect() : wrongAnswerTwo());
 }

//check value of the third button - this is always the right answer
function checkThirdValue(setNumberCorrect) { 
 
return (thirdValue  ? incrementNumberCorrect() : wrongAnswerOne() );
 }   


//get the answer right
function incrementNumberCorrect()  {
  setAnswerColorThree("green")
  playSoundCorrect()
  animeJiggle()
  setNumberCorrect(prevValue => prevValue = prevValue+1)



congratsMessage()


  //move the focus of button to an incorrect answer
  document.getElementById('focusMe').focus()
 
 
}

//increment the  Inc Dec
function passNumberIncDec(numberIncDec){
  setnumberIncDec (numberIncDec => numberIncDec + 1)

}

//wrong answer button 1

function wrongAnswerOne() {
  playSoundWrong()
  setAnswerColorOne("red")
  {setProgress(percentRange > 0 ? percentRange - 10 : 0)}
}

//wrong answer button 2

function wrongAnswerTwo() {
playSoundWrong()
setAnswerColorTwo("red")
{setProgress(percentRange > 0 ? percentRange - 10 : 0)}
}

//shuffle the message array
function shuffleMessageArray() {
 
  let messageArray = ["great","super","fab","right","correct","yes!","yeah","congratulations","go for it","good one","thats it","keep going",]
  setMessageArrayBoop  (whatevs => messageArray = messageArray) 
  for (let i = messageArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [messageArray[i], messageArray[j]] = [messageArray[j], messageArray[i]];
  }
  
  return messageArray
  
  } 

//show congrats message and increase bonus bar 

function congratsMessage() {
shuffleMessageArray()
setCongrats(messageArrayBoop[0])
{setProgress(percentRange < 100 ? percentRange + 10 : 100)}

  
  setTimeout(() => {
    setCongrats(<span>&nbsp;</span>)
}, 1800);

clearTimeout()


setThingsForNextQuestion()

}
 

//after a correct or wrong answer do this

function setThingsForNextQuestion() {
  setAnswerColorOne("goldenrod")
  setAnswerColorTwo("goldenrod")
  setAnswerColorThree("goldenrod")

  makeRandTableNumber()
  

  
  
}



  //progress Bar

  const Range = (props) => {
      return (
          // render current the filled range of progress bar along its width
          <div className="range" style={{width: `${props.percentRange}%`}}/>
          
      );
  }

  const ProgressBar = (props) => {
      return (
          <div className="progress-bar">
              {/*render available progress bar’s limit*/}
              <Range percentRange={props.percentRange}/>
              
          </div>
      );
  }



  const ProgressBarContainer = () => {
  // init state through hook func useState()
  // const [percentRange, setProgress] = useState(0);

      return (
          <div className="progressBarContainer">
          
          
          {/*pass the percentageRange state to other components*/}
          <ProgressBar percentRange={percentRange}/>
              <div className="toggle-buttons">
                  {/* call setProgress func on button click and bind the callback*/}
                  {/* depending on the percentageRange condition to decrease /*/}
                  {/* increase in 20% range and reset the progress bar status*/}
                  {/* <button className="progressButton" onClick={() => setProgress(percentRange > 0 ?
                      percentRange - 10 : 0)}>Decrease
                  </button>
                  <button className="progressButton" onClick={() => setProgress(percentRange < 100 ? percentRange + 10 : 100)}>Increase</button>
                  <button className="progressButton" onClick={() => setProgress(0)}>Reset</button>*/}
                  <p className="bonusBarText">Bonus boost bar {(percentRange)} percent done</p>
              </div> 
          </div>
      );
  }

  //Timer display
  const Timer = () => {
  
    return (
      <div> {seconds} seconds</div>
         
    )
  }

  //toggle timer isActive
  function toggle() {
    setTimerIsActive(!timerIsActive);
  }

  //reset timer
  function reset() {
    setSeconds(0);
    setTimerIsActive(false);
  }

  

  //do this when game ends
    function endGame () {

          setTimerIsActive(false)
          setCountdownSeconds(countdownSeconds => countdownSeconds = 3)
        
          setTimeout(() => {
            
            setShowGame(!showGame)
            setShowEndGame(!showEndGame)
            let guitar = new window.Pizzicato.Sound('sounds/Guitar.wav', function() {
  
              guitar.play();
            })
            
        }, 800);

        clearTimeout()
        
        
          
        }

return (

    
      <div>


      
      {showStartScreen &&
      <div className="userGameChoice">
      <h1 className="gametitle">Times Table Game</h1>
       
       <span className="userGameTableChoice">
      <h2>Choose your times table</h2>
      <button className="plusminusbutton" onClick={setTableChoiceDown}> - </button><span className="choicetext"> {tableNumber} </span><button className="plusminusbutton" onClick={setTableChoiceUp}> + </button>
      </span>
      <span className="userGameTableChoice2">
      <h2 className="yellowtext">How many questions do you want?</h2> 
      <button className="plusminusbutton" onClick={setFinishTotalDown}> - </button> <span className="yellowtext choicetext"> {finishTotal} </span>
      <button className="plusminusbutton" onClick={setFinishTotalUp}> + </button>
      </span>
      <div className="noofquestionscontainer">
      <span className="questionsselectbuttonscontainer">
          <button className="numberofquestions" onClick={() => setFinishTotalButton(finishTotal = 5)}>5</button>
          <button className="numberofquestions" onClick={() => setFinishTotalButton(finishTotal = 10)}>10</button>
          <button className="numberofquestions" onClick={() => setFinishTotalButton(finishTotal = 15)}>15</button>
          <button className="numberofquestions" onClick={() => setFinishTotalButton(finishTotal = 20)}>20</button>
          <button className="numberofquestions" onClick={() => setFinishTotalButton(finishTotal = 25)}>25</button>
          </span>
        
      </div>
      <h2><button className="startnewgame"  onClick={countdownToGame}>start</button></h2>
      <p>v 1.2.2</p>
      </div>
          }

      {showCountdownScreen &&
        <div className="countingcontainer" >
        <h1>{messageCountdown}</h1>
        <br/>
        <br/>
        <div id="countdownanime">
        <h2 className="countingcontainernums"  >{countdownSeconds}</h2>
        </div>
       
        
        </div>
      }    
  

      {showGame &&
        <div className="game">
        <span className="tableTest">
        <p>Go for <strong>{finishTotal}</strong> correct answers on the <strong>{tableNumber}
        </strong> times table</p>
        </span>
        <span className="question funkyShadow"> 
        {/* this is where the question is set */}
        <p className="fadeInAnimated ">{randTableNumber} x {secondValue} = ?</p>
        </span>
      
      <span className="buttonRow">
      
      <button id="focusMe"
       className="answers fadeInAnimated" autofocus
       style={{order: (arrayBoop[0]), backgroundColor: (answerColorOne)}}
       onClick={checkFirstValue}>{firstRndValue}</button>
      
      <button className="answers fadeInAnimated"
      style={{order: (arrayBoop[1]), backgroundColor: (answerColorTwo)}} 
      
       onClick={checkSecondValue}>{secondRndValue}</button>

      <button className="answers fadeInAnimated"
      style={{order: (arrayBoop[2]), backgroundColor: (answerColorThree)}}
       onClick={checkThirdValue}>{thirdValue}</button>
     </span>
     

     <span className="message">
     <audio id="audio2"><source src="sounds/xylo.wav" type="audio/mp3"></source></audio>
     
      <p id="firstanime" className="fadeInAnimated congrats">{congrats}</p>
      </span>

      <span className="correctStats">
      <p className="fadeInAnimated">{numberCorrect} correct ...so far  &nbsp;
      {/* <span role="img" aria-label={"emoji"}>&#128540;</span> */}
      </p>
      </span>
      <p>
      <span className="timer">
        {/* <span role="img" aria-label={"emoji"}>&#x23f1;</span>  */}
        <Timer />
      </span></p>
      
      <ProgressBarContainer />
      </div>
    }



    {showEndGame &&

    <div className="welldone">
    
    <h1>Well done</h1>
    <h2 className="yellowtext">You did it in {(JSON.stringify(seconds))} blazingly fast seconds</h2>
    <h3>You completed {(percentRange)} percent of the bonus bar</h3>
    <p className="bonusbar"><ProgressBar percentRange={percentRange}/></p>
    <h3>You answered each question in an average of {((JSON.stringify(seconds))/(finishTotal)).toFixed(2)} seconds</h3>
    {/* <h2>Your speed is chipmunk<span role="img" aria-label={"emoji"}>&#128063;</span> </h2>
    <h2>Your accuracy is rainbow<span role="img" aria-label={"emoji"}>&#1040397;</span> </h2> */}
    
    <p><button className="startnewgame" onClick={countdownToGame}>try again</button></p>
    <p><button className="endgamechangetimestable" onClick={userGameChoice}>change times table</button></p>
    <p><button className="endgamechangequestions" onClick={userGameChoice}>change number of questions</button></p>
    </div> }


  </div>

    
    )



  
  }
export default App;
